import styled from 'styled-components';

export const WrapperStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.superBig;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
  a {
    padding: 8px;
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.green;
    }};
    text-decoration: none;
    font-family: inherit;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkGreen;
      }};
    }
  }
`;
